// extracted by mini-css-extract-plugin
export default {"root":"FileHistory__root---IMcL","content":"FileHistory__content--6IODG","header":"FileHistory__header--3-mBn","description":"FileHistory__description--2Zp4J"};